/**
 * Services Popup functionality
 */

export function initServicesPopup() {
    const serviceItems = document.querySelectorAll('.acc_services__item');
    const centralPopup = document.getElementById('centralPopup');
    const popupTitle = document.getElementById('popupTitle');
    const popupDescription = document.getElementById('popupDescription');
    const popupServices = document.getElementById('popupServices');
    const popupTeamImages = document.getElementById('popupTeamImages');
    const popupCTAButton = centralPopup ? centralPopup.querySelector('.acc_services__popup-cta .btn') : null;
    
    if (!serviceItems.length || !centralPopup || !window.servicesData) return;

    let hoverTimeout;

    serviceItems.forEach(item => {
        // Mouse enter - show central popup with service data
        item.addEventListener('mouseenter', function(e) {
            clearTimeout(hoverTimeout);
            
            const serviceIndex = parseInt(item.dataset.service);
            const serviceData = window.servicesData[serviceIndex];
            
            if (!serviceData) return;
            
            // Populate popup content
            popupTitle.textContent = serviceData.title;
            popupDescription.textContent = serviceData.description;
            
            // Populate services/tags
            popupServices.innerHTML = '';
            serviceData.tags.forEach(tag => {
                const tagElement = document.createElement('span');
                tagElement.className = 'tag';
                tagElement.textContent = tag;
                popupServices.appendChild(tagElement);
            });
            
            // Populate team images
            popupTeamImages.innerHTML = '';
            serviceData.team_images.forEach(image => {
                const imageContainer = document.createElement('div');
                imageContainer.className = 'acc_services__popup-team-image';
                const img = document.createElement('img');
                img.src = image;
                img.alt = 'Team member';
                imageContainer.appendChild(img);
                popupTeamImages.appendChild(imageContainer);
            });
            
            // Update the "EN SAVOIR PLUS" button link
            if (popupCTAButton && serviceData.expertise_link) {
                popupCTAButton.href = serviceData.expertise_link;
            }
            
            // Show popup after small delay
            hoverTimeout = setTimeout(() => {
                centralPopup.style.opacity = '1';
                centralPopup.style.visibility = 'visible';
                centralPopup.style.transform = 'translate(-50%, -50%)';
                
                // Adjust popup position if it goes outside viewport
                adjustPopupPosition(centralPopup, e);
            }, 100);
        });

        // Mouse leave - hide popup with delay
        item.addEventListener('mouseleave', function(e) {
            clearTimeout(hoverTimeout);
            
            // Check if mouse is moving to popup
            const relatedTarget = e.relatedTarget;
            if (relatedTarget && centralPopup && centralPopup.contains(relatedTarget)) {
                return; // Don't hide if moving to popup
            }
            
            hoverTimeout = setTimeout(() => {
                hideCentralPopup();
            }, 150);
        });
    });

    // Keep popup visible when hovering over it
    if (centralPopup) {
        centralPopup.addEventListener('mouseenter', function() {
            clearTimeout(hoverTimeout);
        });

        centralPopup.addEventListener('mouseleave', function() {
            hoverTimeout = setTimeout(() => {
                hideCentralPopup();
            }, 150);
        });
    }

    function hideCentralPopup() {
        if (centralPopup) {
            centralPopup.style.opacity = '0';
            centralPopup.style.visibility = 'hidden';
            centralPopup.style.transform = 'translate(-50%, calc(-50% + 20px))';
        }
    }

    function adjustPopupPosition(popup, e) {
        const rect = popup.getBoundingClientRect();
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;
        
        // Reset any previous adjustments
        popup.style.left = '50%';
        popup.style.top = '50%';
        
        // Check if popup goes outside right edge
        if (rect.right > viewportWidth - 20) {
            const adjustment = (rect.right - viewportWidth + 40) / rect.width * 100;
            popup.style.left = `${50 - adjustment}%`;
        }
        
        // Check if popup goes outside left edge
        if (rect.left < 20) {
            const adjustment = (20 - rect.left) / rect.width * 100;
            popup.style.left = `${50 + adjustment}%`;
        }
        
        // Check if popup goes outside bottom edge
        if (rect.bottom > viewportHeight - 20) {
            popup.style.top = 'auto';
            popup.style.bottom = '100%';
            popup.style.transform = 'translate(-50%, -10px)';
        }
        
        // Check if popup goes outside top edge
        if (rect.top < 20) {
            popup.style.top = '100%';
            popup.style.bottom = 'auto';
            popup.style.transform = 'translate(-50%, 10px)';
        }
    }

    // Hide popup when clicking outside
    document.addEventListener('click', function(e) {
        const clickedItem = e.target.closest('.acc_services__item');
        const clickedPopup = e.target.closest('#centralPopup');
        if (!clickedItem && !clickedPopup) {
            hideCentralPopup();
        }
    });

    // Hide popup on scroll
    let scrollTimeout;
    window.addEventListener('scroll', function() {
        hideCentralPopup();
        
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
            // Popup can reappear after scroll ends
        }, 200);
    }, { passive: true });
}